export const OBJDEFINE = {
  SERVER: '서버',
  DBMS: '데이터베이스',
  NETDEVICE: '네트워크 장비',
  NETINTERFACE: '인터페이스',
  WIRELESS_DEVICE: '무선 장비',
  FMS_SENSOR: '센서',
  E2E_SERVICE: 'E2E',
  SERVICE: '서비스',
  VMS_OBJECT: '가상화',
  WAS: '인스턴스',
};

export const MANAGETYPE_OBJDEFINE = {
  SMS: ['SERVER'],
  DBMS: ['DBMS'],
  NMS: ['NETDEVICE', 'WIRELESS_DEVICE'],
  FMS: ['FMS_SENSOR'],
  E2E: ['E2E_SERVICE'],
  SVC: ['SERVICE'],
  VMS: ['VMS_OBJECT'],
  APM2X: ['WAS'],
};

export const SVC_ELEMENT_TYPE = {
  SERVER: ['objName', 'ipaddress', 'objtypeName'],
  NETDEVICE: ['objName', 'ipaddress', 'objCompanyName'],
  WIRELESS_DEVICE: ['objName', 'ipaddress', 'objCompanyName'],
  NETINTERFACE: ['objName', 'ipaddress'],
  DBMS: ['objName', 'ipaddress', 'objtypeName'],
  E2E_SERVICE: ['serviceName', 'httpUrl', 'protocol'],
};

export const VMS_OBJTYPE = {
  VDC: '데이터센터',
  VCL: '호스트 클러스터',
  VHO: '호스트',
  VVM: 'VM',
  VDSC: '스토리지 클러스터',
  VDS: '스토리지',
};

export const APM_OBJTYPE = {
  INSTANCE_TIER: '티어',
  INSTANCE: '인스턴스',
  APPLICATION_TIER: '티어',
  APPLICATION: '어플리케이션',
  BIZ: '비즈니스',
  KEY_TRS: '키 트랜잭션',
};



// WEBPACK FOOTER //
// ./src/constants/objdefine.js